import styled from 'astroturf/react';

const Close = styled('span')`
  font-size: 1.6rem;
  margin-left: 15px;
`;

const ErrorMessageWrapper = styled('div')`
  button {
    display: block;
    margin-top: 10px;
  }
`;

export default {
  Close,
  ErrorMessageWrapper,
};
